document.documentElement.classList.add('js');

(function () {
  var toggle = document.querySelector('.menu-toggle');
  var menu = document.getElementById('main-menu');
  var toast = document.querySelector('.toast');
  var messages = {
    adding: toast && toast.dataset.adding || 'Adding…',
    added: toast && toast.dataset.added || '✓ Added to cart',
    success: toast && toast.dataset.success || 'Product added to your cart',
    retry: toast && toast.dataset.retry || 'Try again',
    error: toast && toast.dataset.error || 'Could not add the product. Please try again.'
  };
  var returnFocus = null;

  function closeMenu(restoreFocus) {
    if (!toggle || !menu) return;
    toggle.setAttribute('aria-expanded', 'false');
    menu.classList.remove('is-open');
    document.body.classList.remove('menu-open');
    if (restoreFocus && returnFocus) returnFocus.focus();
  }

  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.classList.toggle('is-open', !open);
      document.body.classList.toggle('menu-open', !open);
      if (!open) {
        returnFocus = toggle;
        var firstLink = menu.querySelector('a');
        if (firstLink) window.setTimeout(function () { firstLink.focus(); }, 0);
      }
    });
    menu.addEventListener('click', function (event) {
      if (event.target.closest('a')) closeMenu();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') closeMenu(true);
    });
    document.addEventListener('click', function (event) {
      if (!menu.hasAttribute('data-persistent-menu') && toggle.getAttribute('aria-expanded') === 'true' && !menu.contains(event.target) && !toggle.contains(event.target)) closeMenu(false);
    });
  }

  function notify(message, isError) {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.toggle('is-error', Boolean(isError));
    toast.classList.add('is-visible');
    window.clearTimeout(notify.timeout);
    notify.timeout = window.setTimeout(function () { toast.classList.remove('is-visible'); }, 3200);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('form[action*="/cart/add"]') || !window.fetch) return;
    event.preventDefault();
    var button = form.querySelector('button[type="submit"], button:not([type])');
    if (!button || button.disabled) return;
    var original = button.getAttribute('data-add-text') || button.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = messages.adding;

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart');
        return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (count) { count.textContent = cart.item_count; });
        button.textContent = messages.added;
        notify(messages.success);
      })
      .catch(function () {
        button.textContent = messages.retry;
        notify(messages.error, true);
      })
      .finally(function () {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        window.setTimeout(function () { button.textContent = original; }, 1800);
      });
  });
})();

(function () {
  var root = document.documentElement;
  var toggle = document.querySelector('[data-theme-toggle]');
  var colorMeta = document.getElementById('ThemeColorMeta');
  var media = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;

  function currentTheme() {
    return root.dataset.theme === 'dark' ? 'dark' : 'light';
  }

  function updateToggle(theme) {
    if (!toggle) return;
    var nextLabel = theme === 'dark' ? toggle.dataset.lightLabel : toggle.dataset.darkLabel;
    toggle.setAttribute('aria-label', nextLabel);
    toggle.setAttribute('title', nextLabel);
    toggle.setAttribute('aria-pressed', String(theme === 'dark'));
    var label = toggle.querySelector('[data-theme-label]');
    if (label) label.textContent = nextLabel;
  }

  function applyTheme(theme, remember) {
    root.dataset.theme = theme;
    root.style.colorScheme = theme;
    if (colorMeta) colorMeta.content = theme === 'dark' ? colorMeta.dataset.dark : colorMeta.dataset.light;
    updateToggle(theme);
    if (remember) {
      try { localStorage.setItem('winmaroc-theme', theme); } catch (error) {}
    }
  }

  applyTheme(currentTheme(), false);

  if (toggle) {
    toggle.addEventListener('click', function () {
      applyTheme(currentTheme() === 'dark' ? 'light' : 'dark', true);
    });
  }

  if (media) {
    var followSystem = function (event) {
      try {
        if (!localStorage.getItem('winmaroc-theme')) applyTheme(event.matches ? 'dark' : 'light', false);
      } catch (error) {}
    };
    if (media.addEventListener) media.addEventListener('change', followSystem);
    else if (media.addListener) media.addListener(followSystem);
  }
})();

